import { entries } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const toneMap: Record<string, { bubble: string; meta: string }> = {
  primary: {
    bubble: "bg-primary-100 text-primary-700",
    meta: "bg-primary-100 text-primary-800",
  },
  accent: {
    bubble: "bg-accent-100 text-accent-700",
    meta: "bg-accent-100 text-accent-800",
  },
  secondary: {
    bubble: "bg-secondary-100 text-secondary-700",
    meta: "bg-secondary-100 text-secondary-800",
  },
};

export default function EntryGrid() {
  return (
    <section id="entry" className="scroll-mt-32 bg-background-100/70 border-y border-background-200 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="分站入口条"
            icon="ri-direction-line"
            title="六个方向入口，先挑再进去"
            desc="首页把各分站按内容方向拆成入口，每一块只讲自己的题材。带着目标进来的人可以直接对号入座，不必从主站信息流里一条条往上翻。"
          />
          <span className="hidden lg:flex items-center gap-2 font-label text-xs text-foreground-500 whitespace-nowrap">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-cursor-line text-[14px]"></i>
            </span>
            点击任意入口卡片即可定位
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {entries.map((item) => {
            const tone = toneMap[item.tone] ?? toneMap.secondary;
            return (
              <a
                key={item.name}
                href="#blocks"
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <span className={`w-11 h-11 flex items-center justify-center rounded-md ${tone.bubble}`}>
                    <i className={`${item.icon} text-[20px]`}></i>
                  </span>
                  <span className={`px-2.5 py-1 rounded-full font-label text-[11px] ${tone.meta}`}>
                    {item.meta}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
                  {item.name}
                </h3>
                <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600 flex-1">
                  {item.desc}
                </p>
                <span className="mt-5 inline-flex items-center gap-1 font-label text-xs text-foreground-700 group-hover:text-primary-700 transition-colors">
                  进入该方向
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-[13px]"></i>
                  </span>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}